import {SearchParam} from './client.const';

export const SEARCH_KEYWORD_MAX_LENGTH = 128;

export function NormalizeSearchKeyword(value: string | null | undefined): string {
  const safe = typeof value === 'string' ? value : '';
  return safe.trim().slice(0, SEARCH_KEYWORD_MAX_LENGTH);
}

export function NormalizeSearchParamKeyword(param: SearchParam | null | undefined): SearchParam {
  const out: SearchParam = {...(param ?? {})};

  if ('keyword' in out) {
    const keyword = NormalizeSearchKeyword(out.keyword);
    if (keyword) {
      out.keyword = keyword;
    } else {
      delete out.keyword;
    }
  }

  return out;
}
